import {Action} from 'redux'
import {NabilAuctionModel} from '../Model/Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialNabilAuctionState: INabilAuctionState = {
  data: {
    nabilAuction: [],
    meta: [],
    categoryList: [],
  },
  sortNabilAuctionData: [],
  nabilAuctionList: {nabilAuction: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface INabilAuctionState {
  data?: {
    nabilAuction?: NabilAuctionModel[]
    meta?: {[key: string]: string | number}[]
    categoryList?: any[]
  }
  sortNabilAuctionData?: INabilAuctionState[]
  nabilAuctionList?: {nabilAuction: NabilAuctionModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: INabilAuctionState = initialNabilAuctionState,
  action: ActionWithPayload<INabilAuctionState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_NABIL_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        nabilAuctionList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_NABIL_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // GET NabilAuction DATA
    case actionTypes.GET_NABIL_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_NABIL_AUCTION_SUCCESS: {
      return {...state, data: {...state.data, ...action.payload}, loading: false}
    }

    case actionTypes.GET_NABIL_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // Add NabilAuction
    case actionTypes.ADD_NABIL_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_NABIL_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_NABIL_AUCTION: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    // Update NabilAuction
    case actionTypes.UPDATE_NABIL_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_NABIL_AUCTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // Delete
    case actionTypes.DELETE_NABIL_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_NABIL_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    // Enable
    case actionTypes.ENABLE_NABIL_AUCTION_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_NABIL_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    // Disable
    case actionTypes.DISABLE_NABIL_AUCTION_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_NABIL_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }

    // Single Enable
    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUCCESS: {
      const changedData: any = action.payload?.data?.nabilAuction
      let newData = state?.data?.nabilAuction?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, nabilAuction: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    // Single Disable
    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUCCESS: {
      const changedData: any = action.payload?.data?.nabilAuction
      let newData = state?.data?.nabilAuction?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, nabilAuction: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_NABIL_AUCTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_NABIL_AUCTION_SUCCESS: {
      return {
        ...state,
        sortNabilAuctionData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_NABIL_AUCTION_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_NABIL_AUCTION_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortNabilAuctionData: [],
      }
    }

    // category list
    case actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          categoryList: action.payload,
        },
        loading: false,
      }
    }

    case actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_FINISH: {
      return {...state, loading: false}
    }

    default:
      return state
  }
}
